module.exports = __webpack_public_path__ + "static/img/MG@3x.ce09050d.png";